import LogoBar from './components/LogoBar'
import Hero from './components/Hero'
import ExpertCards from './components/ExpertCards'
import OnTheDay from './components/OnTheDay'
import WhoWeAre from './components/WhoWeAre'

// UK Construction Week 2026 "Talk to an Expert" landing page. Standalone
// campaign surface — no site nav. Structure: logo bar → hero → expert cards
// → on the day → divider → who we are. Copy source: UKCW landing page copy,
// 18 Sept 2026.
//
// Footer (Privacy/legal links) removed again — this is David's decision, not
// Charly's: there's no completed privacy statement or supporting legal copy
// for this campaign page to link to, it's out of scope for this build, and
// David will add it back once that content exists. See docs/build-log.md,
// amendment pass 12.
export function UkcwLandingPage() {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="mx-auto max-w-content">
                <LogoBar />
                <Hero />
                <ExpertCards />
                <OnTheDay />
                {/* Pink divider between "How does this work?" and "What is
                    unimo?" — was turquoise, corrected per Charly, then briefly
                    shortened and flush-left, reverted back to this full-width,
                    text-gutter-inset treatment per Charly. */}
                <hr className="mx-8 mt-8 border-t-2 border-unimo-site-pink lg:mx-16" />
                <WhoWeAre />
            </div>

        </div>
    )
}

export default UkcwLandingPage
